// extracted by mini-css-extract-plugin
module.exports = {"routetab":"routetab_routetab__3O8Dl","nav":"routetab_nav__3PQnW","active":"routetab_active__1GItW","content":"routetab_content__1A7Yp"};